import React from 'react';
import { RfqDetailData } from '../type';
import RfqFilesThumbnailViewerPresenter from './RfqFilesThumbnailViewerPresenter';
import {
  CapaPcbServiceType,
  CapaQuotationServiceType
} from '@generated/graphql';

interface Props {
  matches?: boolean;
  data?: RfqDetailData;
  isPreview?: boolean;
}

const RfqFilesThumbnailViewerContainer: React.FC<Props> = ({
  matches,
  data,
  isPreview
}) => {
  const rfqId = data?.id;
  const serviceType = data?.serviceType as CapaQuotationServiceType;
  const drawingFiles = (data?.drawingFiles ?? []).map((file) => {
    return {
      fileId: file.fileId,
      fileName: file.fileName ?? ''
    };
  });
  const referenceFiles = data?.referenceFiles ?? [];
  const referenceImageFiles = referenceFiles
    .filter((file) => {
      const fileExtension =
        file.fileName &&
        file.fileName.slice(file.fileName.lastIndexOf('.') + 1).toLowerCase();

      return (
        fileExtension?.includes('jpg') ||
        fileExtension?.includes('jpeg') ||
        fileExtension?.includes('png')
      );
    })
    .map((file) => {
      return {
        fileId: file.fileId,
        fileName: file.fileName ?? ''
      };
    });

  const fabricationFiles = (data?.pcb?.fabricationFiles ?? []).map((file) => {
    return {
      fileId: file.fileId,
      fileName: file.fileName ?? ''
    };
  });

  const isPcb = data?.serviceType === CapaQuotationServiceType.Pcb;

  const pcbWithDesign =
    isPcb &&
    (data?.pcb?.services ?? []).some(
      (service) => service.serviceType === CapaPcbServiceType.CircuitDesign
    );

  const imageFiles =
    isPcb && !pcbWithDesign
      ? fabricationFiles
      : (isPcb && pcbWithDesign) ||
        serviceType === CapaQuotationServiceType.Design
      ? referenceImageFiles
      : drawingFiles;

  return (
    <RfqFilesThumbnailViewerPresenter
      key={rfqId}
      matches={matches}
      rfqId={isPreview ? '' : rfqId}
      serviceType={serviceType}
      files={imageFiles}
      canDownload={true}
    />
  );
};

export default RfqFilesThumbnailViewerContainer;
